"use strict";
/** @jsxRuntime classic */
/** @jsx jsx */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegularNavigation = void 0;
var theme_ui_1 = require("theme-ui");
var MenuItem_1 = require("../../atoms/MenuItem/MenuItem");
var RegularNavigation = function (_a) {
    var links = _a.menuItems;
    return (theme_ui_1.jsx(theme_ui_1.Flex, { sx: { height: "88px", display: ["none", "none", "flex"] } }, links.map(function (_a) {
        var href = _a.href, text = _a.text, onClick = _a.onClick;
        return (theme_ui_1.jsx(MenuItem_1.MenuItem, { href: href, key: text, onClick: onClick }, text));
    })));
};
exports.RegularNavigation = RegularNavigation;
